import './App.css';
import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from "react";
import ReputationScreen from './screens/ReputationScreen.jsx';


Amplify.configure(amplifyconfig);

function App() {
  const location = useLocation();
  const navigation = useNavigate();
  const [showAndroidDownloadPopup, setShowAndroidDownloadPopup] = useState(false);
  const [profileId, setProfileId] = useState(null);

  useEffect(() => {
    if (location.pathname.startsWith("/reputation/")) {
      const id = location.pathname.split("/").pop(); // get "123456789"
      setProfileId(id);
    }
  }, [location.pathname]);

  return (
    <div className="App app-container">
      {
        showAndroidDownloadPopup && <AndroidPlayStorePopUp oncloseFunction={() => setShowAndroidDownloadPopup(false)} />
      }
      {profileId ? (
        <Routes>
          {/* Directly go to Reputation screen with the id */}
          <Route path="/reputation/:id" element={<ReputationScreen profileId={profileId} />} />
        </Routes>
      ) : (
        <InitLoaderScreen />
      )}
    </div>
  );
}

const InitLoaderScreen = () => {
  useEffect(() => {
    window.scrollTo({ top: 1, behavior: 'smooth' });
  }, []);
  
  return (
    <div style={{display: 'flex', width: '100%', height: '100%', alignContent: 'center', justifyContent: 'center'}}>
      <img src={require('./data/loadinggiff.gif')} style={{objectFit: "cover",}} />
    </div>
  );
}

const AndroidPlayStorePopUp = ({oncloseFunction}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 480);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      oncloseFunction();
    }, 3000); // auto close after 3s

    return () => clearTimeout(timer);
  }, [oncloseFunction]);

  return(
    <div style={styles.modalContainer} onClick={oncloseFunction}>
        <div style={{...styles.topContainer, width: isMobile ? "100%" : 480,}}>
            <div style={styles.popupContainer} onClick={(e) => e.stopPropagation()}>
                <p style={{...styles.messageTextMain, color: "#484848"}}>Download the app</p>
                <div style={styles.divider}></div>
                <p style={styles.messageText}>
                  Shink mobile app is available for our android users
                </p>
                <div style={styles.row} onClick={() => {window.open('https://play.google.com/store/apps/details?id=com.shinkapp', '_blank')}}>
                    <p style={{color: '#A545FF', fontSize: 14, fontFamily: 'MPLUS1p-Regular',}}>Download now!</p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default App;

const styles = {
  row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      height: '30px',
      width: '90%',
      cursor: 'pointer'
  },
  messageText: {
      fontSize: '13px',
      fontWeight: '500',
      color: '#444444',
      marginBottom: '4px',
      textAlign: 'left',
      fontFamily: 'MPLUS1p-Regular',
      width: '90%',
  },
  divider: {
      width: '90%',
      height: '1px',
      backgroundColor: '#EEEEEE',
      margin: '5px 0',
  },
  messageTextMain: {
      fontSize: '16px',
      marginBottom: '0',
      textAlign: 'center',
      fontWeight: '700',
      color: '#D82D7E',
  },
  popupContainer: {
      backgroundColor: '#fff',
      padding: '0px 0',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
      flexDirection: 'column', alignSelf: 'center', width: '80%',
      position: 'absolute',
      top: 0
  },
  topContainer: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    justifyContent: "center",
  },
  modalContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    zIndex: 4000,
  }
}